import { convertFlagsArrayToObjects } from 'utils/misc';

import { LoadingOverlay } from 'components/shared';
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { DutyCodeFormValues } from '../type';
import AddGeneralDutyCodeForm from './AddGeneralDutyCodeForm';
import { EditGeneralDutyCodeForm } from './EditGeneralDutyCodeForm';
import { queries } from 'RestAPIs/rapini';
import { DutyCode } from 'generated/index';

const convertToFormData = (dutyCode: DutyCode): DutyCodeFormValues => {
  return {
    id: dutyCode.dutyCodeId,
    displayDutyCode: dutyCode.dutyCode ?? '',
    description: dutyCode.description,
    colorCode: dutyCode.colorCode,
    validFrom: new Date(dutyCode.validFrom),
    validTo: new Date(dutyCode.validTo),
    flags: convertFlagsArrayToObjects(dutyCode.flags ?? []),
    periods: dutyCode.periods,
    canBeDeleted: dutyCode.canBeDeleted,
    periodsCanBeEdited: dutyCode.periodsCanBeEdited
  };
};

const AddOrEditForm = ({ rowId, handleClose }: FormComponentProps) => {
  const { isFetching, data } = queries.useGetDutyCode(rowId as number, {
    enabled: !!rowId
  });

  if (isFetching) {
    return <LoadingOverlay loading={true} />;
  }

  if (data) {
    return (
      <EditGeneralDutyCodeForm
        handleClose={handleClose}
        data={convertToFormData(data)}
      />
    );
  }

  return <AddGeneralDutyCodeForm handleClose={handleClose} />;
};

export default AddOrEditForm;
